import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import TopView from '../components/templates/TopView';
import QuestionView from '../components/templates/QuestionView';
import EditView from '../components/templates/EditView';
import LetterView from '../components/templates/LetterView';
import MessageView from '@/components/templates/MessageView';

// パスに基づいてクラス名を取得する関数
const getPathClass = (pathname: string): string => {
  if (pathname === '/') return 'page-top';
  if (pathname === '/question') return 'page-question';
  if (pathname.startsWith('/edit')) return 'page-edit';
  if (pathname.startsWith('/letter')) return 'page-letter';
  if (pathname.startsWith('/message')) return 'page-message';
  return 'page-default';
};

// 内部コンポーネント（useLocationを使用するため）
const RouterContent: React.FC = () => {
  const location = useLocation();
  const pathClass = getPathClass(location.pathname);

  // ページが変わる度にスクロール位置をトップにする
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className={`page-wrapper ${pathClass}`}>
      <div className='page-container'>
        <Routes>
          <Route path='/' element={<TopView />} />
          <Route path='/question' element={<QuestionView />} />
          <Route path='/message' element={<MessageView />} />
          <Route path='/edit/' element={<EditView />} />
          <Route path='/letter/:id' element={<LetterView />} />
        </Routes>
      </div>
    </div>
  );
};

const Router: React.FC = () => {
  return (
    <BrowserRouter>
      <RouterContent />
    </BrowserRouter>
  );
};

export default Router;
